import { createGlobalStyle } from "styled-components";
import *  as fontsModule from './fonts/fonts.module.css';
import { ThemeTypes } from "./Theme";

export const GlobalStyle = createGlobalStyle<{theme:ThemeTypes}>`

    ${fontsModule}

    /************* Basic CSS Setup *************/

    /* Box sizing rules */
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    
    html {
      font-size: 100%;
    }
    
    body {
      margin: 0;
      padding: 0;
      overflow-x: hidden;
      height: 100vh;
      text-rendering: optimizeSpeed;
      font-family: ${({ theme }) => theme.fonts.primary};
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.main.text};
      background: ${({ theme }) =>  theme.colors.main.background};
      line-height: 1;
    }

    /* TODO: Write a HEX to RGB Converter for this */
    :root {
      --ion-background-color: ${({ theme }) =>  theme.colors.main.background};
      --ion-background-color-rgb: 40,40,40;
    
      --ion-text-color:${({ theme }) => theme.colors.main.text};
      --ion-text-color-rgb: 255,255,255;

      --toastify-color-light: #000;
      --toastify-colo-darl:#000;
      --toastify-text-color-light: #EE8476;
      --toastify-text-color-dark: #EE8476;
    }

    a, a:visited, a:active {
      text-decoration:none;
      color:inherit;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    ul,
    figure,
    blockquote,
    dl,
    dd {
      padding: 0;
      margin: 0;
    }
    button {
      border: none;
      background-color: transparent;
      font-family: inherit;
      padding: 0;
      cursor: pointer;
    }

    /* Set core root defaults */

    html:focus-within {
      scroll-behavior: smooth;
    }

    /* A elements that don't have a class get default styles */

    a:not([class]) {
      text-decoration-skip-ink: auto;
    }
    
    /* Make images easier to work with */

    img,
    picture {
      max-width: 100%;
    }
    
    /* Inherit fonts for inputs and buttons */

    input,
    button,
    textarea,
    select {
      font: inherit;
    }
    /* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
    
    @media (prefers-reduced-motion: reduce) {
      html:focus-within {
        scroll-behavior: auto;
      }
    
      *,
      *::before,
      *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
    }

`;